/**
 * Binary search target index in items
 * @template I, T
 * @param {I[]} items
 * @param {T} target
 * @param {(target: T, item: I) => number} compare
 * @return {number} index
 */
export default function binarySearch(items, target, compare) {
  let start = 0;
  let end = items.length - 1;

  while (start <= end) {
    let middle = Math.floor((start + end) / 2);

    const diff = compare(target, items[middle]);

    if (diff === 0) {
      return middle;
    } else if (diff > 0) {
      start = middle + 1;
    } else {
      end = middle - 1;
    }
  }

  return -1;
}
